<template>
    <div class="btn btn-danger" @click="dismissUser">
        Zwolnij pracownika
    </div>
</template>

<script>
export default {
    name: 'UserDismiss',
    created() {
        this.$emit( 'loading', false )
    },
    methods: {
        dismissUser() {
            this.$emit( 'loading', true )
            this.$http.delete( `users/${ this.$route.params.id }` )
                .then( () => {
                    this.$toastr.success( 'Użytkownik zwolniony' )
                    this.$emit( 'loading', false )
                    this.$router.push( '/uzytkownicy' )
                } )
                .catch( err => {
                    this.$toastr.error( err )
                    this.$emit( 'loading', false )
                } )
        }
    }
}
</script>

